// https://github.com/gmpetrov/databerry/blob/main/packages/ui/src/Input.tsx
import React from 'react'
import FormControl from '@mui/joy/FormControl'
import FormHelperText from '@mui/joy/FormHelperText'
import FormLabel from '@mui/joy/FormLabel'
import Textarea from '@mui/joy/Textarea'
import Typography from '@mui/joy/Typography'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { useController } from 'react-hook-form'

const TextareaInFormControl = ({ control, name, label, required, helper, ...rest }) => {
  const {
    field,
    fieldState,
  } = useController({
    name: name,
    // rules: rules,
    control: control,
  })

  return (
    <FormControl required={required} error={fieldState.invalid}>
      <FormLabel>{label}</FormLabel>
      <Textarea variant='outlined' minRows={2} ref={field.ref} value={field.value} disabled={field.disabled} onBlur={field.onBlur} onChange={field.onChange} {...rest} />
      {fieldState.error && <FormHelperText><InfoOutlined />{fieldState.error.message}</FormHelperText>}
      {helper && <Typography level='body-sm'>{helper}</Typography>}
    </FormControl>
  )
}

export default TextareaInFormControl

// const Textarea_ = React.forwardRef((props, ref) => {
//   const { errors } = useFormState({
//     control: props.control
//   })
//   const errorMsg = R.path([props?.name, 'message'], errors) || ''
//   const { label, helperText, ...rest } = props
//   const helper = errorMsg || helperText
//   return (
//     <FormControl {...props.formControlProps} required={props.required} error={!!errorMsg}>
//       {!props.hidden && label && (
//         <FormLabel
//           sx={{
//             ...(props.disabled
//               ? {
//                   color: 'text.disabled'
//                 }
//               : {})
//           }}
//         >
//           {label}
//         </FormLabel>
//       )}
//       <Textarea
//         ref={ref}
//         minRows={2}
//         variant='outlined'
//         {...rest}
//         // error={!!errorMsg}
//         // {...(errorMsg
//         //   ? {
//         //       helperText: errorMsg,
//         //     }
//         //   : {})}
//       />
//       {helper && <FormHelperText>{helper}</FormHelperText>}
//     </FormControl>
//   )
// })
// export default Textarea_
